"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addClassName = exports.setBaseClassName = void 0;
var baseClassName = 'elevio__';
function setBaseClassName(base) {
    baseClassName = base;
}
exports.setBaseClassName = setBaseClassName;
function addClassName(name) {
    return "" + baseClassName + name;
}
exports.addClassName = addClassName;
//# sourceMappingURL=classes.js.map